// extracted by mini-css-extract-plugin
export default {"wrapper":"lasuXnPhwc9Gor88boPH","noDataAlert":"OE9JIivKR6fu5lwW_P_H","noDataDescription":"ojokFdzEVuQWeIFlDr9c","noDataDescriptionContent":"NaS52H18KwKhEXNZ7TPb"};